// Тексты и время для экрана «Розыгрыш» и баннера на главном. Время розыгрыша — по Москве
// (сервер присылает свои часы: now; разница с часами телефона учитывается).
import { getMoneyType, toAppMoney } from '../custom_views/insta_custom_views/utils_android/UtilsAndroid';

export function plural(n, one, few, many) {
    const m10 = n % 10;
    const m100 = n % 100;
    if (m10 === 1 && m100 !== 11) return one;
    if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return few;
    return many;
}

// Приз в валюте приложения: «2 500 💎» (неразрывно — сумма не отрывается от значка при переносе)
export function prizeText(rubles, isUpmob) {
    const n = Number(toAppMoney(rubles));
    const shown = isFinite(n) ? n.toLocaleString('ru-RU') : String(toAppMoney(rubles));
    return shown + '\u00A0' + String(getMoneyType(isUpmob)).trim();
}

const pad = (n) => (n < 10 ? '0' : '') + n;

// «05:12:33» (до суток) или «1 д 03:12:33»
export function countdownText(ms) {
    const s = Math.max(0, Math.floor(ms / 1000));
    const d = Math.floor(s / 86400);
    const h = Math.floor((s % 86400) / 3600);
    const m = Math.floor((s % 3600) / 60);
    const sec = s % 60;
    return (d > 0 ? d + ' д ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
}

// «21:00»
export function drawTimeText(hour, minute) {
    return pad(Number(hour) || 0) + ':' + pad(Number(minute) || 0);
}

// Местное время розыгрыша, если телефон не в московском поясе: «у вас 19:00»
export function localTimeHint(drawAtMs) {
    const d = new Date(drawAtMs);
    if (d.getTimezoneOffset() === -180) return '';
    return 'у вас ' + pad(d.getHours()) + ':' + pad(d.getMinutes());
}

const MONTHS = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
// '2026-10-30' → «30 октября»
export function dayText(day) {
    const parts = String(day || '').split('-');
    if (parts.length !== 3) return day;
    return Number(parts[2]) + ' ' + MONTHS[Number(parts[1]) - 1];
}

// Конец предложения: «Пётр И.» уже с точкой — второй не добавляем
export function withDot(text) {
    const s = String(text || '').trim();
    return /[.!?…]$/.test(s) ? s : s + '.';
}

export function placeText(place) {
    return place + '-е место';
}

export function medal(place) {
    return place === 1 ? '🏆' : place === 2 ? '🥈' : place === 3 ? '🥉' : '';
}

// Призы за места в рублях: [за 1-е, за 2-е, …]. Сервер до призов за места присылал только prize
export function prizesOf(src) {
    if (src && Array.isArray(src.prizes) && src.prizes.length) return src.prizes.map((p) => Number(p) || 0);
    return src && Number(src.prize) > 0 ? [Number(src.prize)] : [];
}

// Приз финалиста, чьё место объявлено (у старого сервера — только у победителя)
export function finalistPrize(f, show) {
    if (!f || !f.place) return 0;
    if (typeof f.prize === 'number') return f.prize;
    return f.place === 1 && show ? Number(show.prize) || 0 : 0;
}

export function prizeCount(prizes) {
    return prizes.filter((p) => p > 0).length;
}

// «5 призов до 2 500 💎», а если приз один — «2 500 💎»
export function prizesShort(prizes, isUpmob) {
    const count = prizeCount(prizes);
    const top = prizes.length ? Math.max(...prizes) : 0;
    if (count <= 1) return prizeText(top, isUpmob);
    return count + ' ' + plural(count, 'приз', 'приза', 'призов') + ' до ' + prizeText(top, isUpmob);
}

// Призы по местам начиная с fromPlace: [«2-е место — 750 💎», «3-е — 500 💎», «4-е и 5-е — по 250 💎»].
// Одинаковые призы подряд — вместе; места без приза пропускаются
export function ladderParts(prizes, isUpmob, fromPlace = 2) {
    const groups = [];
    for (let place = fromPlace; place <= prizes.length; place++) {
        const p = prizes[place - 1];
        if (!(p > 0)) continue;
        const last = groups[groups.length - 1];
        if (last && last.prize === p && last.to === place - 1) last.to = place;
        else groups.push({ from: place, to: place, prize: p });
    }
    return groups.map((g, k) => {
        const one = g.from === g.to;
        const places = one ? g.from + '-е' : g.to === g.from + 1 ? g.from + '-е и ' + g.to + '-е' : g.from + '–' + g.to + '-е';
        return places + (k === 0 ? (one ? ' место' : ' места') : '') + ' — ' + (one ? '' : 'по ') + prizeText(g.prize, isUpmob);
    });
}

export function ladderText(prizes, isUpmob, fromPlace = 2) {
    return ladderParts(prizes, isUpmob, fromPlace).join(', ');
}

// Строка над финалистами во время показа
export function showStatus(show) {
    if (!show) return 'Розыгрыш начинается';
    if (show.finished) return 'Победитель определён';
    const next = show.next;
    if (!next) return 'Подводим итоги';
    if (next.kind === 'finalist') return show.finalists.length === 0 ? 'Выбираем финалистов' : 'Финалисты: ' + show.finalists.length + ' из ' + show.total;
    if (next.kind === 'place') return 'Объявляем ' + placeText(next.place);
    return show.total > 1 ? 'И победитель' : 'Победитель';
}
